import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag, ArrowRight, ArrowLeft } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const Cart11 = () => {
    const navigate = useNavigate();
    const [showEmpty, setShowEmpty] = useState(false);

    const [cartItems, setCartItems] = useState([
        { id: 1, name: 'Royal Black Sherwani', price: 24999, quantity: 1, size: '42', color: 'Black', image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Ivory Silk Kurta Set', price: 5999, quantity: 1, size: 'M', color: 'Ivory', image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Charcoal Nehru Jacket', price: 7499, quantity: 2, size: 'L', color: 'Charcoal', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(items => items.map(item => item.id === id ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item));
    };

    const removeItem = (id) => {
        setCartItems(items => items.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shipping = subtotal > 5000 ? 0 : 299;
    const total = subtotal + shipping;
    const isEmpty = showEmpty || cartItems.length === 0;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header cartCount={cartItems.reduce((s, i) => s + i.quantity, 0)} />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[1200px] mx-auto">
                        <div className="mb-8">
                            <div className="w-10 h-0.5 mb-4" style={{ backgroundColor: '#D97706' }} />
                            <h1 className="text-3xl sm:text-4xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                                YOUR CART
                            </h1>
                        </div>

                        {isEmpty ? (
                            <div className="text-center py-20">
                                <ShoppingBag size={48} style={{ color: '#44403C', margin: '0 auto 16px' }} />
                                <h2 className="text-xl font-semibold mb-2" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase' }}>Your cart is empty</h2>
                                <p className="text-sm mb-8" style={{ color: '#A8A29E' }}>Add some items to get started</p>
                                <button
                                    onClick={() => navigate('/template11/shop')}
                                    className="inline-flex items-center gap-2 px-8 py-3 text-sm tracking-[0.15em] uppercase"
                                    style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}
                                >
                                    Continue Shopping <ArrowRight size={16} />
                                </button>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                                {/* Cart Items */}
                                <div className="lg:col-span-2 space-y-4">
                                    {cartItems.map(item => (
                                        <div key={item.id} className="flex gap-4 p-4" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                            <div className="w-24 h-32 sm:w-28 sm:h-36 flex-shrink-0 overflow-hidden">
                                                <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex justify-between items-start">
                                                    <div>
                                                        <h3 className="text-sm font-semibold mb-1" style={{ color: '#FAFAF9' }}>{item.name}</h3>
                                                        <p className="text-xs mb-3" style={{ color: '#A8A29E' }}>Size: {item.size} | Color: {item.color}</p>
                                                    </div>
                                                    <button onClick={() => removeItem(item.id)} style={{ background: 'none', border: 'none', color: '#A8A29E', cursor: 'pointer' }}>
                                                        <X size={18} />
                                                    </button>
                                                </div>
                                                <div className="flex justify-between items-end">
                                                    <div className="inline-flex items-center" style={{ border: '1px solid #44403C' }}>
                                                        <button onClick={() => updateQuantity(item.id, -1)} className="w-8 h-8 flex items-center justify-center" style={{ background: 'none', border: 'none', color: '#FAFAF9', cursor: 'pointer' }}><Minus size={14} /></button>
                                                        <span className="w-8 text-center text-sm" style={{ color: '#FAFAF9' }}>{item.quantity}</span>
                                                        <button onClick={() => updateQuantity(item.id, 1)} className="w-8 h-8 flex items-center justify-center" style={{ background: 'none', border: 'none', color: '#FAFAF9', cursor: 'pointer' }}><Plus size={14} /></button>
                                                    </div>
                                                    <span className="text-base font-semibold" style={{ color: '#D97706' }}>{`\u20B9${(item.price * item.quantity).toLocaleString('en-IN')}`}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <button
                                        onClick={() => navigate('/template11/shop')}
                                        className="inline-flex items-center gap-2 text-sm mt-4"
                                        style={{ color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500, letterSpacing: '1px', textTransform: 'uppercase', background: 'none', border: 'none', cursor: 'pointer' }}
                                    >
                                        <ArrowLeft size={16} /> Continue Shopping
                                    </button>
                                </div>

                                {/* Order Summary */}
                                <div className="p-6" style={{ backgroundColor: '#292524', border: '1px solid #44403C', alignSelf: 'start' }}>
                                    <h2 className="text-lg font-semibold mb-6" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                                        ORDER SUMMARY
                                    </h2>
                                    <div className="space-y-3 mb-6" style={{ borderBottom: '1px solid #44403C', paddingBottom: '16px' }}>
                                        <div className="flex justify-between text-sm">
                                            <span style={{ color: '#A8A29E' }}>Subtotal</span>
                                            <span style={{ color: '#FAFAF9' }}>{`\u20B9${subtotal.toLocaleString('en-IN')}`}</span>
                                        </div>
                                        <div className="flex justify-between text-sm">
                                            <span style={{ color: '#A8A29E' }}>Shipping</span>
                                            <span style={{ color: shipping === 0 ? '#D97706' : '#FAFAF9' }}>{shipping === 0 ? 'FREE' : `\u20B9${shipping}`}</span>
                                        </div>
                                    </div>
                                    <div className="flex justify-between text-lg font-semibold mb-6">
                                        <span style={{ color: '#FAFAF9', fontFamily: "'Oswald', sans-serif" }}>TOTAL</span>
                                        <span style={{ color: '#D97706' }}>{`\u20B9${total.toLocaleString('en-IN')}`}</span>
                                    </div>
                                    <button
                                        onClick={() => navigate('/template11/checkout')}
                                        className="w-full flex items-center justify-center gap-2 py-4 text-sm tracking-[0.15em] uppercase transition-colors duration-300"
                                        style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}
                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F59E0B')}
                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#D97706')}
                                    >
                                        Proceed to Checkout <ArrowRight size={16} />
                                    </button>
                                    {shipping > 0 && (
                                        <p className="text-xs text-center mt-3" style={{ color: '#A8A29E' }}>
                                            Free shipping on orders above {`\u20B95,000`}
                                        </p>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Cart11;
